module.exports = __webpack_public_path__ + "static/media/cty2.b6c7945f.png";